import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_GETZPAY_URL || "";

export const billingApi = {
  getCreditCards: async (token: string) => {
    return axios.get(`${API_BASE_URL}/v1/creditcards`, {
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  payTargetMarketing: async (token: string, payload: any) => {
    return axios.post(`${API_BASE_URL}/v1/payment/targetmarketing`, payload, {
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};
